import { observer } from "mobx-react-lite";
import { useModal } from "react-hooks-use-modal";
import { SwipeUser } from "../models/api/SwipeUser";
import { rootStore } from "../StApp";
import { DateDetailModal } from "./DateDetailModal";
import { motion } from "framer-motion";
import { VoiceIntro } from "./VoiceIntro";

type DateCardProps = {
    imgUrl: string,
    user: SwipeUser
}
//https://picsum.photos/id/231/200/300
const DateCard = (props: DateCardProps) => {

    var myLatestTap: any
    var timer: any = 0;
    var doubleTap = false

    const user = props.user

    const [Modal, open, close, isOpen] = useModal('root', {
        preventScroll: false,
        closeOnOverlayClick: true
    });

    const glow = rootStore.dateshipStore.likedUids.includes(user.uid) ? 'glowing-like' : null

    function regTap() {

        if (timer == 0) {
            timer = 1;
            timer = setTimeout(function () {
                timer = 0;
                if (doubleTap == false) {
                    doubleTap = true
                    open()
                }
                //doubleTap = false // Add this for final sol

            }, 300);
        }
        else {
            doubleTap = true
            rootStore.dateshipStore.toggleLike(user.uid)

        }

    }

    return (
        <motion.div className={`card date-card relative ${glow}`} style={{ backgroundImage: `url(${props.imgUrl})` }}
            onClick={regTap} >
            <DateDetailModal Modal={Modal} close={close} data={{ mainImgUrl: props.imgUrl, user: user }} />
            {/* <img className='fill-img' src="https://picsum.photos/id/231/200/300" alt="" /> */}
            <div style={{ position: 'absolute', bottom: 5, left: 5, color: 'white', }} >
                <VoiceIntro uid={props.user.uid} />
                <div className='flex-row center-both' >
                    <h3 style={{ marginTop: 0, marginBottom: 0, backgroundColor:'#0000007d' }} >{user.name}, {user.age}</h3>
                    <span className="material-icons" style={{
                        marginLeft: 2,
                        color: 'green',
                    }}>
                        verified
                    </span>
                </div>
            </div>
        </motion.div>
    )
}

export default observer(DateCard)